// extracted by mini-css-extract-plugin
module.exports = {"section":"C_section__1X7YL","revealDown":"C_revealDown__znn1W"};